function getSizeGuideDocument(sizeGuideDocumentContent) {
  if (!sizeGuideDocumentContent) {
    return void 0;
  }
  const {
    findOutSizeCTA,
    findOutSizeDescription,
    findOutSizeImage,
    findOutSizeSubtitle,
    findOutSizeTitle,
    measureDescription,
    measureDescriptionImage,
    measureImage,
    measureSteps,
    measureTitle,
    sizeGuideSizeCompound,
    sizeTitle
  } = sizeGuideDocumentContent;
  return {
    findOutSizeCTA: findOutSizeCTA && {
      icon: findOutSizeCTA.icon,
      link: {
        url: findOutSizeCTA.link.url,
        label: findOutSizeCTA.link.label,
        alt: findOutSizeCTA.link.alt,
        openInNewWindow: findOutSizeCTA.link.openInNewWindow,
        style: findOutSizeCTA.link.style
      }
    },
    findOutSizeDescription,
    findOutSizeImage,
    findOutSizeSubtitle,
    findOutSizeTitle,
    measureDescription,
    measureDescriptionImage,
    measureImage,
    measureSteps,
    measureTitle,
    sizeGuideSizeCompound,
    sizeTitle
  };
}
export {
  getSizeGuideDocument
};
//# sourceMappingURL=get-size-guide-document.js.map
